var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.data.className},[_vm._v(_vm._s(_vm.moment(_vm.data.text).format('lll')))])
}
var staticRenderFns = []

export { render, staticRenderFns }